import ModalBox from './ModalBox.vue';
export default ModalBox;
